import type { AuthProviderProps } from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";

/** Cognito settings the deploy workflow bakes in at build time. */
export const cognito = {
  authority: import.meta.env.VITE_COGNITO_AUTHORITY ?? "",
  clientId: import.meta.env.VITE_COGNITO_CLIENT_ID ?? "",
  /** Hosted sign-in domain, e.g. https://login.theparedown.app or the amazoncognito.com default. */
  domain: import.meta.env.VITE_COGNITO_DOMAIN ?? "",
  /** True when the pool offers Google, so the landing page can send people straight to Google. */
  googleSignIn: import.meta.env.VITE_GOOGLE_SIGN_IN === "true",
};

export const authConfigured = Boolean(cognito.authority && cognito.clientId);

const origin = typeof window !== "undefined" ? window.location.origin : "";

export const oidcConfig: AuthProviderProps = {
  authority: cognito.authority,
  client_id: cognito.clientId,
  redirect_uri: `${origin}/`,
  response_type: "code",
  scope: "openid email profile",
  automaticSilentRenew: true,
  userStore: typeof window !== "undefined" ? new WebStorageStateStore({ store: window.localStorage }) : undefined,
  onSigninCallback: () => {
    // Drop ?code=&state= from the address bar after the redirect.
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};

/**
 * Extra authorize parameters that skip the hosted page and go straight to
 * Google's consent screen. Without them Cognito shows its own page, which is
 * still the route for email + password.
 */
export const googleSignInArgs = { extraQueryParams: { identity_provider: "Google" } };

/** Cognito needs its own logout endpoint; the OIDC end_session one is not standard there. */
export function signOutUrl(): string {
  const u = new URL("/logout", cognito.domain);
  u.searchParams.set("client_id", cognito.clientId);
  u.searchParams.set("logout_uri", `${window.location.origin}/`);
  return u.toString();
}
